

export default () => {
    $("div.tags-header-panel").find("div").on("click", function(e){
        e.preventDefault();
        $("div.tags-header-panel").find("div").removeClass("active");
        $(this).addClass("active");
    });

    /**
     * Extract the last directory of the url before de year date and compare with the header tags to apply the active class
     */
    const url = location.pathname;
    let tagArrayUrl = url.match('(\\/[A-za-z\\-\\_\\/]+\\/)(20\\d{2}\\/(01|02|03|04|05|06|07|08|09|10|11|12)\\/\\d{2}\\/.+\\.html)?');
    if (tagArrayUrl != null) {
      let tagUrl = tagArrayUrl[1].toLocaleLowerCase().split('/');
      let lastSegmentUrl = tagUrl.pop() || tagUrl.pop();

      if (lastSegmentUrl) {
        $(".tags-header-panel > div > a").each(function() {
          const tag = this.href.split('/');
          const lastSegment = tag.pop() || tag.pop();

          if (lastSegment === lastSegmentUrl) {
            this.parentElement.classList.add("active");
          }
        });
      }
    }
}
